import * as React from "react";
import { Button, Menu, ActionIcon, useMantineColorScheme } from "@mantine/core";
import { Plus, ChevronDown, FolderPlus, Table, BarChart3, LayoutDashboard, FileSignature } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { TabGroupIcon } from "@bi-studio/shared/components";

interface AddNewEntityButtonProps {
    folderId?: string | null;
    onNewFolder?: () => void;
}

export function AddNewEntityButton({ folderId = "root", onNewFolder }: AddNewEntityButtonProps) {
    const navigate = useNavigate();
    const { colorScheme } = useMantineColorScheme();

    const renderDropdown = () => (
        <Menu.Dropdown
            style={{
                backgroundColor: colorScheme === 'dark' ? 'var(--modal-bg)' : undefined,
                borderColor: colorScheme === 'dark' ? 'var(--modal-border)' : undefined,
                backdropFilter: 'blur(var(--modal-blur))'
            }}
        >
            {onNewFolder && (
                <Menu.Item
                    leftSection={<FolderPlus size={16} />}
                    onClick={onNewFolder}
                >
                    New Folder
                </Menu.Item>
            )}
            <Menu.Item
                leftSection={<Table size={16} />}
                onClick={() => navigate(`/create/report?folderId=${folderId || "root"}`)}
            >
                New Report
            </Menu.Item>
            <Menu.Item
                leftSection={<BarChart3 size={16} />}
                onClick={() => navigate(`/create/chart?folderId=${folderId || "root"}`)}
            >
                New Chart
            </Menu.Item>
            <Menu.Item
                leftSection={<LayoutDashboard size={16} />}
                onClick={() => navigate(`/create/dashboard?folderId=${folderId || "root"}`)}
            >
                New Dashboard
            </Menu.Item>
            <Menu.Item
                leftSection={<FileSignature size={16} />}
                onClick={() => navigate(`/create/form?folderId=${folderId || "root"}`)}
            >
                New Form
            </Menu.Item>
            <Menu.Item
                leftSection={<TabGroupIcon size={16} />}
                onClick={() => navigate(`/create/tab-group?folderId=${folderId || "root"}`)}
            >
                New Tab Group
            </Menu.Item>
        </Menu.Dropdown>
    );

    return (
        <React.Fragment>
            <Menu shadow="md" width={200} position="bottom-end">
                <Menu.Target>
                    <Button color="black" c="white" className="w-full sm:w-auto" leftSection={<Plus size={16} />} rightSection={<ChevronDown size={14} />} visibleFrom="sm">
                        Add New
                    </Button>
                </Menu.Target>
                {renderDropdown()}
            </Menu>
            <Menu shadow="md" width={200} position="bottom-end">
                <Menu.Target>
                    <ActionIcon variant="filled" color="black" c="white" size="lg" hiddenFrom="sm">
                        <Plus size={18} />
                    </ActionIcon>
                </Menu.Target>
                {renderDropdown()}
            </Menu>
        </React.Fragment>
    );
}
